import { render, staticRenderFns } from "./icon-lib.vue?vue&type=template&id=6d461f54"
import script from "./icon-lib.vue?vue&type=script&lang=js"
export * from "./icon-lib.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports